const deepFreeze = (object) => {
    if (!object || typeof object !== "object" || Object.isFrozen(object)) return object;

    Object.getOwnPropertyNames(object).forEach((name) => {
        const value = object[name];
        if (value && typeof value === "object" && !Object.isFrozen(value)) deepFreeze(value);
    });

    return Object.freeze(object);
};

const freezeHelper = (object) => deepFreeze(object);
freezeHelper.DEEP_FREEZE = deepFreeze;

export const OBJECT_FREEZE_HELPER = freezeHelper;
